import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { MetadatiProtocolloDTO } from "../dto/metadati-protocolloDTO";
import { MetadatiProtocolloVO } from "../vo/metadati-protocolloVO";
import { env } from "@env/environment";
import { MapperDocumentoGescor } from "./gescor/mapper-documento-gescor";
import { MapperClassificaGescor } from "./gescor/mapper-classifica-gescor";
import { DatePipe } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class MapperMetadatiProtocollo
  implements MapperInterface<MetadatiProtocolloDTO, MetadatiProtocolloVO> {
  constructor(
    private mapperDocumentoGescor: MapperDocumentoGescor,
    private mapperClassifica: MapperClassificaGescor,
    private datepipe: DatePipe
  ) {}

  convertVoToDto(vo: MetadatiProtocolloVO): MetadatiProtocolloDTO {
    if (vo != null) {
      const dto = new MetadatiProtocolloDTO();
      dto.numeroProtocollo = vo.numeroProtocollo;
      dto.dataProtocollo = vo.dataProtocollo;
      dto.idBozza = vo.idBozza;
      dto.tipo = vo.tipo;
      dto.classifica = this.mapperClassifica.convertListVoToDto(vo.classifica);
      dto.protocollazioneRiservata = vo.protocollazioneRiservata;
      dto.riferimentoSegnatura = this.mapperDocumentoGescor.convertVoToDto(
        vo.riferimentoSegnatura
      );
      return dto;
    } else {
      return null;
    }
  }
  convertDtoToVo(dto: MetadatiProtocolloDTO): MetadatiProtocolloVO {
    if (dto != null) {
      const vo = new MetadatiProtocolloVO();
      vo.numeroProtocollo = dto.numeroProtocollo;
      vo.dataProtocollo = dto.dataProtocollo;
      vo.idBozza = dto.idBozza;
      vo.tipo = dto.tipo;
      vo.classifica = this.mapperClassifica.convertListDtoToVo(dto.classifica);
      vo.protocollazioneRiservata = dto.protocollazioneRiservata;
      vo.riferimentoSegnatura = this.mapperDocumentoGescor.convertDtoToVo(
        dto.riferimentoSegnatura
      );
      let dateFormatted = new Date(vo.dataProtocollo);
      vo.segnatura =
        env.CODICE_AOO_GRT +
        "/" +
        vo.numeroProtocollo +
        "/" +
        this.datepipe.transform(dateFormatted, "dd/MM/yyyy") +
        "/" +
        vo.classifica[0].livello;
      return vo;
    } else {
      return null;
    }
  }
  convertListVoToDto(voList: MetadatiProtocolloVO[]): MetadatiProtocolloDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }
  convertListDtoToVo(dtoList: MetadatiProtocolloDTO[]): MetadatiProtocolloVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
